import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./shared";

export const SERVICES_LINKS = [
  { to: "/entretien-immeubles-ppe", label: "Entretien d'immeubles & PPE", desc: "Conciergerie et suivi régulier des parties communes" },
  { to: "/nettoyage-professionnel", label: "Nettoyage professionnel", desc: "Régulier ou ponctuel, pour particuliers et professionnels" },
  { to: "/nettoyage-haute-pression", label: "Nettoyage haute pression", desc: "Terrasses, dallages, murs et garages" },
  { to: "/nettoyage-fin-de-bail", label: "Nettoyage fin de bail", desc: "Remise en état avant restitution du logement" },
  { to: "/nettoyage-fin-de-chantier", label: "Nettoyage fin de chantier", desc: "Après construction ou rénovation" },
  { to: "/travaux-entretien", label: "Petits & moyens travaux", desc: "Réparations, maintenance et remise en état" },
  { to: "/debarras", label: "Débarras & évacuation", desc: "Caves, greniers, logements et locaux" },
];

export const Related = ({ current }) => (
  <section className="border-t border-nuit/10 bg-white py-20 lg:py-28" data-testid="related-services">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <Reveal>
        <Overline>Autres prestations</Overline>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-px bg-nuit/10 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES_LINKS.filter((l) => l.to !== current).map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`related-${l.to.slice(1)}`}
            className="group flex items-start justify-between gap-4 bg-white p-6 transition-colors duration-300 hover:bg-brume"
          >
            <div>
              <p className="font-display text-lg font-medium text-nuit">{l.label}</p>
              <p className="mt-1 text-sm leading-relaxed text-nuit/55">{l.desc}</p>
            </div>
            <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-nuit/25 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-lagoon" />
          </Link>
        ))}
      </div>
      <Reveal delay={0.1}>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-6 bg-nuit p-8 lg:p-10">
          <p className="font-display text-xl font-medium text-white sm:text-2xl">Un besoin ? Parlons-en. Devis gratuit.</p>
          <Link
            to="/contact"
            data-testid="related-cta-contact"
            className="whitespace-nowrap rounded-full bg-lagoon px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-nuit transition-colors duration-300 hover:bg-white"
          >
            Demander un devis
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
